// Index route for /bet — all UI handled by parent layout
export default function BetIndex() {
  return null;
}
